<template>
  <div
    class="demo__StatusBadge"
    v-bind:class="['demo__bg--' + style.bg, 'demo__color--' + style.color]"
    :style="{
      ...pos,
    }"
  >
    <span v-if="status.text">
      {{ status.text }}
    </span>
    <span v-else>
      {{ $t("status." + status.type) }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: Object,
      required: true,
    },
    position: {
      type: String,
      required: false,
      default: "right-top",
    },
  },
  data() {
    return {
      colors: {
        free: {
          bg: "brandSecondary",
          color: "black",
        },
        subscription: {
          bg: "gradient",
          color: "white",
        },
        price: {
          bg: "brandPurple",
          color: "white",
        },
        draft: {
          bg: "iconError",
          color: "black",
        },
        archived: {
          bg: "bgDescription",
          color: "black",
        },
        completed: {
          bg: "brandSecondary",
          color: "black",
        },
        default: {
          bg: "brandPrimary",
          color: "white",
        },
      },
      positions: {
        "right-top": { right: "17px", top: "14px" },
        "left-top": { left: "17px", top: "14px" },
        "right-bottom": { right: "17px", bottom: "14px" },
        "left-bottom": { left: "17px", bottom: "14px" },
        default: { right: "17px", top: "14px" },
      },
    };
  },
  computed: {
    style() {
      return this.colors[this.status?.type] || this.colors.default;
    },
    pos() {
      return this.positions[this.position] || this.positions.default;
    },
  },
};
</script>
